// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldPillInput_root__2MS52","inputRoot":"FieldPillInput_inputRoot__1Syr7","inputLabel":"FieldPillInput_inputLabel__1Iqz2"};